import { FilterItemTag } from '@aibees/elephant/feature/search-filters/components/filter-tags';
import {
  ClearButtonType,
  ClearTagsButton,
} from '@aibees/elephant/feature/search-filters/components/filter-tags/components/clear-tags-button';
import { FilterTagList } from '@aibees/elephant/feature/search-filters/components/filter-tags/components/filter-tag-list';
import {
  buildClearItemDraft,
  getFilterTagsFlattened,
} from '@aibees/elephant/feature/search-filters/components/filter-tags/utils';
import { useSearchQueryFilterSetters } from '@aibees/elephant/hooks/use-search-query-filter';
import { classnames } from '@aibees/shared/utils';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { memo, useState } from 'react';
import * as SX from './sx';
import type { AppliedFiltersTagsProps as Props } from './types';

export const AppliedFiltersTags = memo(
  ({ className, tags, ...filter }: Props) => {
    const { setParams } = useSearchQueryFilterSetters();
    const [hoveredItem, setHoveredItem] = useState<string | null>(null);

    const handleClear = (array: FilterItemTag[]) => {
      const draft = buildClearItemDraft(array);
      setParams(draft);
    };

    return (
      <Box
        className={classnames('AppliedFiltersTags', className)}
        display={'flex'}
        flexDirection={'column'}
        gap={1}
        sx={SX.root}
      >
        {tags?.items
          ?.filter((x) => !x.empty)
          .map((item) => {
            const tagList = getFilterTagsFlattened(item);
            const isHovered = hoveredItem === item.name;

            return (
              <Box
                key={item.name}
                onMouseEnter={() => setHoveredItem(item.name ?? null)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  paddingBottom={0.5}
                >
                  <Typography
                    color={'grey.600'}
                    variant="body3"
                    fontWeight={600}
                    lineHeight="24px"
                  >
                    {item.name}
                  </Typography>
                  {isHovered && (
                    <ClearTagsButton
                      type={ClearButtonType.ICON_BUTTON}
                      onClick={() => handleClear(tagList)}
                      count={tagList?.length}
                    />
                  )}
                </Box>
                <Card variant="filled" color="default">
                  <CardContent>
                    <FilterTagList noTitle items={tagList ?? []} />
                  </CardContent>
                </Card>
              </Box>
            );
          })}
      </Box>
    );
  }
);

AppliedFiltersTags.displayName = 'AppliedFiltersTags';
